import http from "../../../http-commonv2";

const inboundGeneral = (data) => {
  return http.post(`/api/v2/stats/inbound/general`, data);
};

const distributionByQueue = (data) => {
  return http.post(`/api/v2/stats/inbound/distributionByQueue`, data);
};

const timeAveragesPerQueue = (data) => {
  return http.post(`/api/v2/stats/inbound/timeAveragesPerQueue`, data);
};

const timelineDistribution = (data) => {
  return http.post(`/api/v2/stats/inbound/timelineDistribution`, data);
};
const timelineAverages = (data) => {
  return http.post(`/api/v2/stats/inbound/timelineAverages`, data);
};
const agentDistributionByQueue = (data) => {
  return http.post(`/api/v2/stats/inbound/agentDistributionByQueue`, data);
};

const agentDistributionByAttempts = (data) => {
  return http.post(`/api/v2/stats/inbound/agentDistributionByAttempts`, data);
};

const StatsService = {
  inboundGeneral,
  distributionByQueue,
  timeAveragesPerQueue,
  timelineDistribution,
  timelineAverages,
  agentDistributionByQueue,
  agentDistributionByAttempts,
};

export default StatsService;
